import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { ProjectSettingAction, InitAction } from "../actions";
import * as projectSettingApi from "../api/projectSetting";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherProjectSetting() {
  yield takeLatest(types.PROJECT_SETTING_STORE_REQUEST, store);
  yield takeLatest(
    types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_REQUEST,
    accountingSoftwareWorker
  );
  yield takeLatest(types.SHARED_CONTACTS_REQUEST, sharedContactsWorker);
  yield takeLatest(types.SET_USER_STATE_REQUEST, setUserStateWorker);
}

function fetchStore(data) {
  return projectSettingApi.store(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectSettingAction.storeSuccess(response.data));
    if (response.data.data && response.data.data.id) {
      localStorage.setItem("use_imprest", response.data.data.use_imprest);
      localStorage.setItem(
        "construction_phase_level",
        response.data.data.construction_phase_level
      );
      localStorage.setItem(
        "construction_component_level",
        response.data.data.construction_component_level
      );
      yield put(InitAction.getSuccess({ project_setting: response.data.data }));
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.storeFailure(error));
  }
}

function fetchList() {
  return projectSettingApi.getList();
}

function* accountingSoftwareWorker() {
  try {
    const response = yield call(fetchList);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectSettingAction.getListSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.getListFailure(error));
  }
}

function sharedContacts() {
  return projectSettingApi.sharedContacts();
}
function* sharedContactsWorker() {
  try {
    const response = yield call(sharedContacts);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectSettingAction.sharedContactsSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.sharedContactsFailure(error));
  }
}

function setUserState(userId, action) {
  return projectSettingApi.setUserState(userId, action);
}
function* setUserStateWorker(action) {
  try {
    const response = yield call(setUserState, action.userId, action.action);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    yield put(ProjectSettingAction.setUserStateSuccess(response.data));
    yield put(ProjectSettingAction.sharedContacts());
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.setUserStateFailure(error.response.data));
  }
}
